/*
 * Copyright '2025' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
import { ApplicationDefinitionAdapter } from "../../routes/application-definition-adapter";
import { ApplicationDefinition } from "../../routes/application-definition.model";
import { CatalogsService } from "./catalogs.service";
import { CatalogConverter } from "./catalog-converter";

export class CatalogToApplicationDefinitionAdapter
  implements ApplicationDefinitionAdapter
{
  private readonly catalogService: CatalogsService;
  private readonly ADMIN_ROUTE_PREFIX = "/admin/";

  constructor(catalogService: CatalogsService) {
    this.catalogService = catalogService;
  }

  public async getApplicationDefinitions(): Promise<ApplicationDefinition[]> {
    const catalogs = await this.catalogService.getCatalogs();
    return catalogs
      .filter(
        (catalog) =>
          !catalog.route.toLowerCase().startsWith(this.ADMIN_ROUTE_PREFIX)
      )
      .map(CatalogConverter.toApplicationDefinition);
  }
}
